import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    HandlerWithResult,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { convertToMinorUnits, getAdyenPaymentDetails } from "@insite/client-framework/Services/PaymentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

export type ValidateStripe3DSPaymentParameter = {
    paymentResult?: any; 
    paymentAmount?: number;
} & HasOnSuccess<ValidateStripe3DSPaymenteResult>;

export interface ValidateStripe3DSPaymenteResult {
    success: boolean;
    adyenPspReference?: string;
    errorMessage?: string;
    paymentAmount?: number;
    currency?: string;
}

type HandlerType = HandlerWithResult<
ValidateStripe3DSPaymentParameter,
ValidateStripe3DSPaymenteResult,
    {
        customerId?: string;
        paymentAmount?: number;
        redirectResult?: string;
        adyenPspReference?: string;
    }
>;

export const ValidatePaymentResult: HandlerType = ({ parameter: { paymentResult, onSuccess } }) => {
    console.log("paymentResult",paymentResult)
    if (
        paymentResult &&
        paymentResult.paymentIntent &&
        paymentResult.paymentIntent.status !== "succeeded"        
    ) {
        onSuccess?.({ success: false });
        return false;
    }
};

export const SetInitialValues: HandlerType = props => { 
    if (props.parameter.paymentAmount) {
        const currencyCode = props.getState().context.session.currency!.currencyCode;
        props.paymentAmount = convertToMinorUnits(props.parameter.paymentAmount, currencyCode);
        props.adyenPspReference = props.parameter.paymentResult.paymentIntent.id;
    }
};

export const ValidateAmount: HandlerType = props => {
    const {
        paymentAmount,
        parameter: { onSuccess },
        getState,
    } = props;

    const state = getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const currencyCode = props.getState().context.session.currency!.currencyCode;
    if (paymentAmount && paymentAmount !== convertToMinorUnits(cartState.value!.orderGrandTotal, currencyCode)) {
        onSuccess?.({
            success: false,
            errorMessage: siteMessage("Adyen_AmountIsDifferent") as string,
            adyenPspReference: props.adyenPspReference,
            paymentAmount,
            currency: props.getState().context.session.currency!.currencyCode,
        });
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.({
        success: true,
        adyenPspReference: props.parameter.paymentResult.paymentIntent.id,
        paymentAmount: props.paymentAmount,
        currency: props.getState().context.session.currency!.currencyCode,
    });
};

export const chain = [
    ValidatePaymentResult,
    SetInitialValues,  
    ValidateAmount,
    ExecuteOnSuccessCallback,
];

const validateStripe3DSPayment = createHandlerChainRunner(chain, "ValidateStripe3DSPayment");
export default validateStripe3DSPayment;
